export interface AuthRequest {
  username?: string;
  password?: string;
  newpassword?: string;
  scope?: string;
  grant_type?: GrantType;
  client_id?: string;
  client_secret?: string;
  refresh_token?: string;
  token?: string,
  email?:string
}

export interface AuthResponse {
  token_type: string;
  expires_in: number;
  access_token: string;
  refresh_token: string;
}

export enum GrantType {
  Password = 'password',
  ClientCredentials = 'client_credentials',
  RefreshToken = 'refresh_token'
}

export enum AllowedPriviledge {
  Read = 'read',
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
  Search = 'search',
  ChangeStatus = 'change_status',
  ReadFull = 'read_full',
  Publish = 'publish'
}

export interface AuthMfaRequest {
  code?: string;
  userId?: string;
  scope?: string;
  grant_type?: GrantType;
  client_id?: string;
  client_secret?: string;
  refresh_token?: string;
  email?:string
}

export interface MfaResponse {
  qr_code?: string;
  code?: number;
  message?: string;
  password_expired?: boolean;
  twoFactorEnabled?: boolean;
}

/** @deprecated Use MfaResponse */
export type MfaEnableResponse = MfaResponse;

export interface PasswordExpiredResponse {
  code?: number;
  username?: string;
  password?: string;
}